/**
 * Escapes HTML special characters to prevent XSS in tooltip rendering.
 */
export function escapeHtml(str: string): string {
  return str.replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
